export default {
    customerInfo_lastName: [
        { required: true, message: '請輸入香港身份證的英文姓氏', trigger: 'blur' }
    ],    
    addressInfoVo_district: [
        { required: true, message: '請選擇地區', trigger: 'blur' }
        // { required: true, validator: (rule, value, callback) => validatorType(rule, value, callback, '請選擇地區'), trigger: 'blur' }
    ],
    addressInfoVo_flatInput: [
        { required: true, message: '請輸入室', trigger: 'blur' }
        // { required: true, validator: (rule, value, callback) => validatorType(rule, value, callback, '請輸入室'), trigger: 'blur' }        
    ],        
}